"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getPlatformKeyboardType = (keyboardType, platform) => {
    const safeKeyboardTypesAcrossPlatforms = [
        'default',
        'email-address',
        'numeric',
        'phone-pad',
        'number-pad',
        'decimal-pad',
    ];
    const iOS = [
        ...safeKeyboardTypesAcrossPlatforms,
        'ascii-capable',
        'numbers-and-punctuation',
        'url',
        'name-phone-pad',
        'twitter',
        'web-search',
    ];
    const android = [
        ...safeKeyboardTypesAcrossPlatforms,
        'visible-password',
    ];
    if (platform === 'android' && keyboardType) {
        return android.includes(keyboardType) ? keyboardType : 'default';
    }
    return (keyboardType && iOS.includes(keyboardType)) ? keyboardType : 'default';
};
exports.default = getPlatformKeyboardType;
